export const soulList = [
  {
    id: 1,
    name: '战争之神 -- 阿瑞斯',
    basicAttrs: '攻击、暴击伤害',
    specialAttrs: '重击、重创、冲锋、冲击、破阵、残忍',
    type: 'danger',
  },
  {
    id: 2,
    name: '智慧之神 -- 雅典娜',
    basicAttrs: '破防、命中率',
    specialAttrs: '分裂、击溃、爆发、虚无、影刃、裂创',
    type: 'primary',
  },
  {
    id: 3,
    name: '狩猎之神 -- 阿尔忒弥斯',
    basicAttrs: '攻击速度、暴击率',
    specialAttrs: '追击、碎骨、收割、收尾、轻灵、精准',
    type: 'success',
  },
]
export const soulClass: Record<number, string> = {
  1: 'war-god',
  2: 'wisdom-god',
  3: 'hunt-god',
}
